import styled from 'styled-components';

export const Wrapper = styled.div``;

export const TicketPageTitle = styled.div`
  margin-bottom: 0;
`;
export const TicketHeadCount = styled.div`
  font-size: ${({ theme }) => theme.fs.xxs};
`;
export const TicketHeadAction = styled.div`
  display: flex;
  align-items: center;
`;

export const TicketHeadButton = styled.button`
  margin-top: 0;
  margin-inline-start: ${({ theme }) => theme.spacing.x4};
`;
// TODO:  active and status
export const TicketStatusTable = styled.div`
  width: 80px;
`;
export const TicketActionTable = styled.div`
  width: 90px;
`;

export const Middle = styled.div`
  margin: auto;
`;
